import { render, staticRenderFns } from "./FilialNotAvailablePanel.vue?vue&type=template&id=50c4fd23&scoped=true"
import script from "./FilialNotAvailablePanel.vue?vue&type=script&lang=js"
export * from "./FilialNotAvailablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c4fd23",
  null
  
)

export default component.exports